import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Case from './Case';
import { getCaseColumns, getCaseGridTemplate } from './columns';
import {
    Table,
    TableHead,
    TableBody,
} from '..';
import './styles.scss';

// TODO Rewrite this to use MUI table components instead of custom table components.
function Cases({ cases }) {
    const { scope } = localStorage;
    const scopeArray = (scope || '').split(' ');
    const hasAccess = (rule) => scopeArray.includes(rule);
    const canViewClinicsColumn = hasAccess('cases.display.clinics:read');
    const canViewLabsColumn = hasAccess('cases.display.labs:read');
    const columns = getCaseColumns(canViewClinicsColumn, canViewLabsColumn);
    const gridTemplateColumns = getCaseGridTemplate(columns);
    const [openIndex, setOpenIndex] = useState(null);
    const checkIndex = (index) => {
        if (index === null) setOpenIndex(null);
        else setOpenIndex(index);
    };

    // State for certain aspects of the case detail view.
    // This state is applied across all cases, so we have to keep it up here.
    const [caseDetailGlobalState, setCaseDetailGlobalState] = useState({
        isRightPanelOpen: true,
        rightPanel: 0, // 0 represents Actions, 1 represents Details
        showRenderTips: true,
    });

    // If a case is opened, disable scroll on the containers behind it.
    // If closed, enable scroll on the containers behind it.
    useEffect(() => {
        document.body.style.overflow = openIndex === null ? 'auto' : 'hidden';
    }, [openIndex]);

    return (
        <Table>
            <TableHead>
                <div className="cases-grid-row cases-grid-head" style={{ gridTemplateColumns }}>
                    {columns.map((column) => (
                        <div className={`heading ${column.key === 'status' ? 'status-heading' : ''}`} key={column.key}>
                            {column.label}
                        </div>
                    ))}
                    <div className="heading heading-spacer" aria-hidden="true" />
                </div>
            </TableHead>
            <TableBody>
                {
                    cases.map((c, i) => (
                        <Case
                            {...c}
                            key={c.id}
                            numCases={cases.length}
                            index={i}
                            open={openIndex != null && i === openIndex}
                            switchOpen={checkIndex}
                            caseDetailGlobalState={caseDetailGlobalState}
                            setCaseDetailGlobalState={setCaseDetailGlobalState}
                        />
                    ))
                }
            </TableBody>
        </Table>
    );
}

Cases.propTypes = {
    cases: PropTypes.arrayOf(PropTypes.shape),
};

Cases.defaultProps = {
    cases: [],
};

export default Cases;
